import { noop } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { SwipeHandler } from '../../SwipeHandler';
import { TIMESGRID_MOBILE_CONFIG } from '../constants/ViewConstants';
import CreateTimesGridControls from './CreateTimesGridControls';

import * as styled from './control-primitives';

const NUM_COLS_TO_DISPLAY = 1;

class MobileTimesGridControls extends PureComponent {
    static propTypes = {
        dates: PropTypes.array,
        isFirstPossibleDateFrame: PropTypes.bool,
        nextBtnClicked: PropTypes.func,
        prevBtnClicked: PropTypes.func,
    };

    static defaultProps = {
        isFirstPossibleDateFrame: false,
        nextBtnClicked: noop,
        prevBtnClicked: noop,
    };

    render() {
        return (
            <SwipeHandler
                onSwipeLeft={this.handleNextArrowClick}
                onSwipeRight={this.handlePreviousArrowClick}
            >
                <styled.MobileWrapper data-test="ap-mobile-controls">
                    {this.renderPreviousButton()}
                    {this.maybeRenderDates()}
                    {this.renderNextButton()}
                </styled.MobileWrapper>
            </SwipeHandler>
        );
    }

    renderPreviousButton() {
        return (
            <styled.MobileNavigationToggle
                data-test="ap-mobile-controls-prev"
                disabled={this.props.isFirstPossibleDateFrame}
                onClick={this.handlePreviousArrowClick}
                title={`Move backward one day (${this.renderDateString(moment(this.props.dates[0]).subtract(1, 'days'))})`}
            >
                <styled.MobileLeftArrow />
            </styled.MobileNavigationToggle>
        );
    }

    renderNextButton() {
        return (
            <styled.MobileNavigationToggle
                data-test="ap-mobile-controls-next"
                disabled={this.props.disableNextArrow}
                onClick={this.handleNextArrowClick}
                title={`Move forward one day (${this.renderDateString(moment(this.props.dates[0]).add(1, 'days'))})`}
            >
                <styled.MobileRightArrow />
            </styled.MobileNavigationToggle>
        );
    }

    renderDateString(date) {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        let dayPrefix = '';
        if (date.isSame(today, 'day')) {
            dayPrefix = 'Today';
        } else if (date.isSame(tomorrow, 'day')) {
            dayPrefix = 'Tomorrow';
        } else {
            dayPrefix = date.format('ddd');
        }

        return `${dayPrefix}, ${date.format('MMM D')}`;
    }

    maybeRenderDates() {
        if (this.props.dates) {
            /**
             * MobileTimesGridContent isn't set up to render more than one row of slots,
             * so there's no point in rendering more than one date
             */
            const date = this.props.dates[0];

            return (
                <styled.MobileRail>
                    <div data-test="ap-mobile-controls-day">
                        {this.renderDateString(date)}
                    </div>
                </styled.MobileRail>
            );
        }
    }

    handlePreviousArrowClick = () => this.props.prevBtnClicked(NUM_COLS_TO_DISPLAY)
    handleNextArrowClick = () => this.props.nextBtnClicked(NUM_COLS_TO_DISPLAY)
}

/* eslint-disable babel/new-cap */
export default (
    CreateTimesGridControls(TIMESGRID_MOBILE_CONFIG)(
        MobileTimesGridControls
    )
);
